module.exports = __webpack_public_path__ + "static/media/logo.3978c8f9.png";